module.exports = __webpack_public_path__ + "static/img/m_tutorial.291a007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_tutorial.jpg
// module id = 180
// module chunks = 1